// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-382c8084] .el-table{font-size:12px}[data-v-382c8084] .el-table thead .el-table__cell{padding:6px 0;background:#fafaf9;color:#666;border-top:1px solid #e1e1e1;border-right:1px solid #dedcda}[data-v-382c8084] .el-table tbody .el-table__cell{padding:2px 0}", ""]);
// Exports
module.exports = exports;
